/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Rule_LockedInputs */

const vi_packaging_bom_rule_locked = /** @type {(inputs: Packaging_Bom_Rule_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư đóng gói — luôn tính trên 1 sản phẩm`)
};

/**

* @param {Packaging_Bom_Rule_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_rule_locked = /** @type {((inputs?: Packaging_Bom_Rule_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Rule_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_rule_locked(inputs)
});